import { paths } from '../paths'

export const HEADER_NAVIGATION_DESCRIPTORS = [
  { path: paths.main, title: 'Проверка' },
  { path: paths.users, title: 'Пользователи' },
  // { path: paths.managers, title: 'Менеджеры' },
  { path: paths.questions, title: 'Вопросы' },
  { path: paths.settings, title: 'Настройки' },
]
